import React, { useRef, useState, useEffect, useContext } from "react";
import { Card } from "../../../../shadcn/components/ui/card";
import { ShortListedPropertyCard } from "../../../../shadcn/components/custom/ShortListedPropertyCard";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../../shadcn/components/ui/tabs";
import { Context, getSearchResults } from "services";
import { DateTime } from "luxon";

interface ShortListedPropertyItems {
  subAssetType?: string;
  price?: string;
  address?: string;
  imageLink?: string;
  propertyLink?: string;
}

interface PropertyByPrice {
  title?: string;
  value?: string;
  children?: ShortListedPropertyItems[];
}

interface PriceMenuCardProps {
  propertiesByPrice: any[];
}

const propertyByPrice: PropertyByPrice[] = [
  {
    title: "All",
    value: "all",
    children: [
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
    ],
  },
  {
    title: "Under 50L",
    value: "under_50L",
    children: [
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
    ],
  },
  {
    title: "Under 1cr",
    value: "under_1cr",
    children: [
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
    ],
  },
  {
    title: "Under 5cr",
    value: "under_5cr",
    children: [
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
      {
        subAssetType: "Flats",
        price: "40,00,000",
        imageLink: "/ShortListedProperty.png",
        address: "Rohini, Delhi",
        propertyLink: "/",
      },
    ],
  },
];

export function BrowsePriceMenu({ propertiesByPrice }: PriceMenuCardProps) {
  return (
    <Tabs defaultValue="all" className="w-full">
      <div className="overflow-auto scrollbar-hide">
        <TabsList className="gap-10 bg-white capitalize font-openSans font-normal text-web-body-md lg:text-web-body-lg leading-4 text-[#A8A8A8]">
          {propertiesByPrice.map((item: any, index: number) => (
            <TabsTrigger key={`item-${index}`} value={item?.value}>
              {item?.title}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {propertiesByPrice.map((item: any, index: number) => (
        <TabsContent
          className="mt-6 lg:mt-9"
          key={`item-${index}`}
          value={item.value}
        >
          <Card className="border-none shadow-none relative">
            <div className=" pb-1  space-y-6 custom-scrollbar">
              {item?.children?.splice(0, 4).map((card: any, index: number) => (
                <ShortListedPropertyCard
                  price={card?.price}
                  key={`card-${index}`}
                  subAssetType={card?.subAssetType}
                  imageLink={card?.imageLink}
                  address={card?.address}
                  propertyLink={card?.propertyLink}
                  subAssetTypeBgcolor="bg-white"
                />
              ))}
            </div>
          </Card>
        </TabsContent>
      ))}
    </Tabs>
  );
}
